/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Status_AvailableInputs */

const vi_vehicle_status_available = /** @type {(inputs: Vehicle_Status_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng`)
};

/**

* @param {Vehicle_Status_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_status_available = /** @type {((inputs?: Vehicle_Status_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Status_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_status_available(inputs)
});